import React, { useEffect, useState, useContext } from "react";
import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";

// API
import ContentService from "../../../services/content.service";

// Context
import { StateContext } from "../../../common/context/StateContext";

// Components
import Typography from "../../../common/components/Typography";
import Loader from "../../../common/components/Loader";
import SwiperContainer from "../../../common/components/SwiperContainer";

// Mui
import Stack from "@mui/material/Stack";

// Images
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

// Utils
import { Colors, PageGutter } from "../../../common/utils/constants";

const Container = styled.section`
    padding: ${PageGutter};
    background-color: white;
    position: relative;

    .swiper {
        margin: 5px !important;
    }

    .swiper-slide {
        height: auto;
    }
`;

const Reviews = () => {
    const { setNotificationMessage } = useContext(StateContext);
    const [isLoading, setIsLoading] = useState(true);
    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        getReviews();
    }, []);

    const getReviews = async () => {
        setIsLoading(true);
        const { status, data } = await ContentService.getReviews();

        if (status) {
            setReviews(data);
            setIsLoading(false);
        } else {
            setIsLoading(false);
            setNotificationMessage({
                message: "Could not fetch list of reviews.",
                type: "error",
            });
        }
    };

    return (
        <Container id="reviews">
            <Typography variant="h4" sx={{ mb: 4 }}>
                Reviews
            </Typography>
            {isLoading ? (
                <Loader />
            ) : (
                <SwiperContainer
                    uniqueKey="reviews"
                    spaceBetween={32}
                    autoplay={true}
                    navigation={false}
                    breakpoints={{
                        600: {
                            slidesPerView: 1,
                        },
                        900: {
                            slidesPerView: 2,
                        },
                        1200: {
                            slidesPerView: 3,
                        },
                    }}
                >
                    {reviews.map((review, index) => (
                        <SwiperSlide key={index}>
                            <Stack
                                sx={{
                                    minHeight: "300px",
                                    height: "100%",
                                    borderRadius: "7px",
                                    background: "#f0f1f573",
                                    pt: 1,
                                    pl: 4,
                                    pr: 4,
                                    pb: 1,
                                }}
                            >
                                <FormatQuoteIcon
                                    color="primary"
                                    sx={{
                                        fontSize: 50,
                                        ml: "-20px",
                                        transform: "rotate(180deg)",
                                    }}
                                />
                                <Typography variant="h6" sx={{ mt: 1 }}>
                                    {review.name}
                                </Typography>
                                <Typography variant="paragraph" sx={{ mb: 2 }}>
                                    {review.country}
                                </Typography>
                                <Typography variant="paragraph">
                                    {review.message}
                                </Typography>
                            </Stack>
                        </SwiperSlide>
                    ))}
                </SwiperContainer>
            )}
        </Container>
    );
};

export default Reviews;
